import { createActions, createReducer } from 'reduxsauce'

import ConsultaOrdemCronologicaPagamentoService from '../../servicos/ConsultaOrdemCronologicaPagamentoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaOrdemCronologicaPagamentoMPInicio: [],
    buscaConsultaOrdemCronologicaPagamentoMPSucesso: ['consultaOrdemCronologicaPagamentoMP'],
    buscaConsultaOrdemCronologicaPagamentoMPErro: ['erro'],
    limpar: [],
    setConsultaOrdemCronologicaPagamentoMPEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaOrdemCronologicaPagamentoMP = (filtro, grupo) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaOrdemCronologicaPagamentoMPInicio())
        let serv = new ConsultaOrdemCronologicaPagamentoService()
        return serv
            .consultarMP(filtro, grupo)
            .then(response => dispatch(Creators.buscaConsultaOrdemCronologicaPagamentoMPSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaOrdemCronologicaPagamentoMPErro(error)))
    }
}

const buscaConsultaOrdemCronologicaPagamentoMPInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaOrdemCronologicaPagamentoMPErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaOrdemCronologicaPagamentoMPSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaOrdemCronologicaPagamentoMP.resultado,
        dataSincronizacaoDados: action.consultaOrdemCronologicaPagamentoMP.dataSincronizacaoDados,
        fonte: action.consultaOrdemCronologicaPagamentoMP.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaOrdemCronologicaPagamentoMPEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP_INICIO]: buscaConsultaOrdemCronologicaPagamentoMPInicio,
    [Types.BUSCA_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP_ERRO]: buscaConsultaOrdemCronologicaPagamentoMPErro,
    [Types.BUSCA_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP_SUCESSO]: buscaConsultaOrdemCronologicaPagamentoMPSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP_ESTADO_DT]: setConsultaOrdemCronologicaPagamentoMPEstadoDT,
})
